import { render, staticRenderFns } from "./auth-child-add.vue?vue&type=template&id=1138d900&scoped=true&"
import script from "./auth-child-add.vue?vue&type=script&lang=js&"
export * from "./auth-child-add.vue?vue&type=script&lang=js&"
import style0 from "./auth-child-add.vue?vue&type=style&index=0&id=1138d900&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1138d900",
  null
  
)

export default component.exports